import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import {
	AssetBlok,
	multiAssetToSingleAsset,
	sizes,
} from "@/components/bloks/Asset";
import { LinkWrapper } from "@/components/ui/LinkWrapper";
import type { BlokHero2, StoryblokMultiasset } from "@/storyblok";
import { Button } from "../../Button";
import styles from "./Hero2.module.css";

export interface Hero2Props
	extends Pick<BlokHero2, "mainTitle" | "secondaryTitle" | "linkVariant">,
		ComponentProps<"section"> {
	href?: string;
	linkText?: string;
	mainSource?: StoryblokMultiasset;
	secondarySource?: StoryblokMultiasset;
	lightMode?: boolean;
}

export const Hero2 = ({
	mainTitle,
	secondaryTitle,
	mainSource,
	secondarySource,
	href,
	linkText,
	linkVariant,
	lightMode,
	className,
	...rest
}: Hero2Props) => {
	return (
		<LinkWrapper href={href}>
			<section className={clsx(styles.root, className)} {...rest}>
				<div className={styles.content}>
					<div className={styles.side}>
						<AssetBlok
							source={multiAssetToSingleAsset(mainSource!)}
							muted
							autoPlay
							loop
							priority
							quality={90}
							sizes={sizes(90, 80)}
						/>
					</div>
					<div className={styles.side} data-viewport="desktop">
						<AssetBlok
							source={multiAssetToSingleAsset(secondarySource!)}
							muted
							autoPlay
							loop
							priority
							quality={90}
							sizes={sizes(90, 80)}
						/>
					</div>
				</div>
				<div className={styles.text}>
					<h1 className={styles.title} data-light={lightMode}>
						{mainTitle}
					</h1>
					<h2 className={styles.title} data-light={lightMode}>
						{secondaryTitle}
					</h2>
					{href && (
						<Button
							className={clsx(
								styles.button,
								linkVariant !== "default" && styles.link,
							)}
							href={href}
						>
							{linkText}
						</Button>
					)}
				</div>
			</section>
		</LinkWrapper>
	);
};
